import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const INACTIVITY_TIMEOUT = 48 * 60 * 60 * 1000; // 48 hours in milliseconds
const CHECK_INTERVAL = 60 * 1000; // Check every minute

export const useInactivityLogout = () => {
  const navigate = useNavigate();
  const lastActivityRef = useRef(Date.now());
  const checkIntervalRef = useRef(null);

  const updateActivity = () => {
    lastActivityRef.current = Date.now();
    localStorage.setItem('lastActivity', Date.now().toString());
  };

  const checkInactivity = () => {
    const sessionToken = localStorage.getItem('sessionToken');

    if (!sessionToken) {
      return; // User not logged in
    }

    const lastActivity = parseInt(localStorage.getItem('lastActivity') || Date.now().toString());
    const now = Date.now();
    const inactiveTime = now - lastActivity;

    if (inactiveTime >= INACTIVITY_TIMEOUT) {
      // User has been inactive for 48 hours, logout
      localStorage.removeItem('sessionToken');
      localStorage.removeItem('lastActivity');
      localStorage.removeItem('userId');
      localStorage.removeItem('userType');
      navigate('/');
    }
  };

  useEffect(() => {
    const sessionToken = localStorage.getItem('sessionToken');

    if (!sessionToken) {
      return; // User not logged in, no need to track
    }

    // Initialize last activity if not set
    if (!localStorage.getItem('lastActivity')) {
      updateActivity();
    }

    // Activity event listeners
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];

    events.forEach(event => {
      window.addEventListener(event, updateActivity);
    });

    // Start checking for inactivity
    checkIntervalRef.current = setInterval(checkInactivity, CHECK_INTERVAL);

    // Check immediately on mount
    checkInactivity();

    // Cleanup
    return () => {
      events.forEach(event => {
        window.removeEventListener(event, updateActivity);
      });

      if (checkIntervalRef.current) {
        clearInterval(checkIntervalRef.current);
      }
    };
  }, [navigate]);

  return null;
};
